module.exports = __webpack_public_path__ + "media/B.21636383.wav";